import Rails from "@rails/ujs";
Rails.start();

// 以下に app/frontend/js 配下のスクリプトをimportする
import { Application } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

Turbo.session.drive = false

import '@fortawesome/fontawesome-free/css/all.css';

// modal-video
import 'modal-video/css/modal-video.css';

// tom-select
import 'tom-select/dist/css/tom-select.bootstrap4.css';

//scss import
import '@/stylesheets/customer.scss';

// js import
import './modal-video-youtube.js';

// Stimulus controllers import
import { AccordionController } from './accordion-controller.js';
import { AccountTypeSwitcherController } from './account-type-switcher-controller.js';
import { AgreementModalController } from './agreement-modal-controller.js';
import { AnnounceCarouselController } from './announce-carousel-controller.js';
import { ApplicationCancelModalController } from './application-cancel-modal-controller.js';
import { ApplicationPurchaseController } from './application-purchase-controller.js';
import { FormTermController } from './form-term-controller.js';
import { IdentityVerificationStatusController } from './identity-verification-status-controller.js';
import { ModalController } from './modal-controller.js';
import { NoEnterSubmitController } from "./no_enter_submit_controller";
import { PopupController } from './popup-controller.js';
import { SameAsRepresentativeController } from "./same-as-representative-controller";
import { SimpleModalController } from "./simple-modal-controller";
import { TabController } from './tab-controller.js';
import { ZipcodeAutofillController } from "./zipcode-autofill-controller";
import TomSelectController from "./tom-select-controller";

// Point system controllers
import { ConvertPointsController } from './convert_points-controller.js';
import { PayoutHistoriesController } from './payout_histories-controller.js';
import { PayoutRequestsCheckboxController } from './payout_requests/checkbox-controller.js';
import { PayoutRequestsController } from './payout_requests/payout-requests-controller.js';
import { PurchasePointsController } from './purchase-points-controller.js';
import { PurchaseTicketController } from './purchase-ticket-controller.js';
import { RootModalController } from './root-modal-controller.js';

// Purchase Ticket Modal controllers (改善案1: モーダル分離)
import { ConfirmModalController } from './confirm-modal-controller.js';
import { ConvertPointsModalController } from './convert-points-modal-controller.js';
import { PointPurchaseModalController } from './point-purchase-modal-controller.js';

// Purchase discount mock controller
import { PurchaseDiscountController } from './purchase-discount-controller.js';

// Harvest Warehouse controller 
import { HarvestWarehouseController } from './harvest_warehouse';

// Start Stimulus application once
const application = Application.start();

// Register all controllers
application.register("accordion", AccordionController);
application.register("account-type-switcher", AccountTypeSwitcherController);
application.register("agreement-modal", AgreementModalController);
application.register("announce-carousel", AnnounceCarouselController);
application.register("application-cancell-modal", ApplicationCancelModalController);
application.register("application-purchase", ApplicationPurchaseController);
application.register("form-term", FormTermController);
application.register("identity-verification-status", IdentityVerificationStatusController);
application.register("modal", ModalController);
application.register("tab", TabController);
application.register("popup", PopupController);
application.register("zipcode-autofill", ZipcodeAutofillController);
application.register("no-enter-submit", NoEnterSubmitController);
application.register("same-as-representative", SameAsRepresentativeController);
application.register("simple-modal", SimpleModalController);
application.register("tom-select", TomSelectController);

// Point system controllers registration
application.register("convert-points", ConvertPointsController);
application.register("payout-histories", PayoutHistoriesController);
application.register("payout-checkbox", PayoutRequestsCheckboxController);
application.register("payout-requests", PayoutRequestsController);
application.register("purchase-points", PurchasePointsController);
application.register("purchase-ticket", PurchaseTicketController);
application.register("root-modal", RootModalController);

// Purchase Ticket Modal controllers registration (改善案1: モーダル分離)
application.register("confirm-modal", ConfirmModalController);
application.register("convert-points-modal", ConvertPointsModalController);
application.register("point-purchase-modal", PointPurchaseModalController);

// Purchase discount mock controller registration
application.register("purchase-discount", PurchaseDiscountController);

// Harvest Warehouse controller 
application.register("harvest-warehouse", HarvestWarehouseController);
